'use client';
import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import GlobalNavigationMenu from '@components/GlobalNavigationMenu';
import { BreadcrumbContextProvider } from '@features/navigation/BreadcrumbContext';
import { PageFormControlsContextProvider } from '@features/navigation/context';
import TopNavigationBar from '@features/navigation/TopNavigationBar';
import SearchModal from '@features/search/SearchModal';
import OrgSettingsModal from '@features/settings/OrgSettingsModal';
import { usePathSyncers } from 'hooks/usePathSyncers';

const PAGE_CONTENT_BORDER_RADIUS = '6px';

const AppLayout = ({ children }: { children: React.ReactNode }) => {
  usePathSyncers();

  return <LayoutBody>{children}</LayoutBody>;
};

const LayoutBody = ({ children }: { children: React.ReactNode }) => {
  return (
    <BreadcrumbContextProvider>
      <PageFormControlsContextProvider>
        <GlobalNavigationMenu>
          <Flex
            flexDirection="column"
            w="100%"
            borderColor="border.light"
            overflow="hidden"
            id="nullifyrisk-content-and-banner-container"
            borderRadius={PAGE_CONTENT_BORDER_RADIUS}
            boxShadow="sm"
          >
            <TopNavigationBar />
            <Box
              id="nullifyrisk-content-container"
              height="100%"
              width="100%"
              overflow="hidden"
              borderRadius="inherit"
            >
              {children}
            </Box>
          </Flex>
          <OrgSettingsModal />
          <SearchModal />
        </GlobalNavigationMenu>
      </PageFormControlsContextProvider>
    </BreadcrumbContextProvider>
  );
};

export default React.memo(AppLayout);
